import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader, getFileDownloadHeaders,
    handleQueryError} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const taxRollApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchTaxRoll: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/tax-rolls?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['taxRolls'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getTaxRollById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-tax-roll-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['taxRollById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportTaxRollData: build.query({
            query: (query) => {
                return {
                    url: `/export/tax-roll`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("tax_rolls"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});


export const {
    useSearchTaxRollQuery,
    useGetTaxRollByIdQuery,
    useLazyExportTaxRollDataQuery,
} = taxRollApi;